// Reveal once: re-hiding on scroll-up re-ran the fade and stuttered scrolling.
export function observeReveals(): () => void {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return

        entry.target.classList.add("active")
        observer.unobserve(entry.target)
      })
    },
    { rootMargin: "0px 0px -20px 0px" }
  )

  document.querySelectorAll(".reveal").forEach((el) => observer.observe(el))

  return () => observer.disconnect()
}

// Video background fade animation utility
export function createVideoFadeController(
  threshold: number = 200,
  fadeDistance: number = 300
) {
  return (scrollY: number, initialOpacity: number = 1): number => {
    if (scrollY <= threshold) {
      return initialOpacity
    } else if (scrollY >= threshold + fadeDistance) {
      return 0
    } else {
      const progress = (scrollY - threshold) / fadeDistance
      return initialOpacity * (1 - progress)
    }
  }
}

// Optimized scroll handler using requestAnimationFrame
export function createScrollHandler(callback: (scrollY: number) => void) {
  let ticking = false

  return () => {
    if (!ticking) {
      requestAnimationFrame(() => {
        callback(window.scrollY)
        ticking = false
      })
      ticking = true
    }
  }
}

// Check if user prefers reduced motion
export function prefersReducedMotion(): boolean {
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches
}
